// Page atteinte quand un user connecté sans abo Coach Pro tente d'ouvrir
// le Dashboard Coach depuis le web. Historiquement c'était un tunnel Stripe :
// depuis qu'on a retiré la gestion des abonnements côté site (tout se fait
// désormais via RevenueCat dans l'app), cette page explique simplement où
// souscrire et propose les liens de téléchargement.
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, verifySession } from "../services/authService";

function ProUpgrade() {
	const navigate = useNavigate();

	useEffect(() => {
		const checkSession = async () => {
			if (!isLoggedIn()) {
				navigate("/login");
				return;
			}
			const isValid = await verifySession();
			if (!isValid) navigate("/login");
		};
		checkSession();
	}, [navigate]);

	return (
		<div className="page">
			<div className="pro-upgrade-container">
				<div className="orange-banner" style={{ maxWidth: 560, minHeight: "auto" }}>
					<h2 className="orange-title" style={{ fontSize: 34 }}>
						👑 GymNote Pro
					</h2>
					<p style={{ color: "rgba(255,255,255,0.7)", marginTop: -6, marginBottom: 24, fontSize: 15, lineHeight: 1.5 }}>
						Le Dashboard Coach web est réservé aux abonnés Pro. La souscription se fait maintenant directement dans l'app mobile GymNote.
					</p>

					<div
						style={{
							background: "rgba(255,255,255,0.06)",
							border: "1px solid rgba(255,255,255,0.12)",
							borderRadius: 14,
							padding: 18,
							marginBottom: 20,
							textAlign: "left",
						}}
					>
						<p style={{ margin: 0, fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.55 }}>
							<strong style={{ color: "#F87B1B" }}>Comment souscrire ?</strong><br />
							1. Ouvre l'app GymNote sur ton téléphone<br />
							2. Va dans <em>Mon compte → Abonnement</em><br />
							3. Choisis <strong>Pro</strong> et suis les instructions<br />
							4. Reviens sur cette page une fois l'abo actif
						</p>
					</div>

					<div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center" }}>
						<a
							href="https://apps.apple.com/fr/app/gymnote-suivi-muscu-coach/id6470710692"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								padding: "12px 22px",
								background: "#000",
								border: "1px solid rgba(255,255,255,0.2)",
								borderRadius: 10,
								color: "#fff",
								textDecoration: "none",
								fontWeight: 600,
								fontSize: 14,
							}}
						>
							App Store
						</a>
						<a
							href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								padding: "12px 22px",
								background: "#000",
								border: "1px solid rgba(255,255,255,0.2)",
								borderRadius: 10,
								color: "#fff",
								textDecoration: "none",
								fontWeight: 600,
								fontSize: 14,
							}}
						>
							Google Play
						</a>
					</div>

					<button
						className="pro-upgrade-back"
						onClick={() => navigate(-1)}
						style={{ marginTop: 24 }}
					>
						Retour
					</button>
				</div>
			</div>
		</div>
	);
}

export default ProUpgrade;
